import {DataTableColumn} from "mantine-datatable";
import {I18n} from "@aws-amplify/core";
import {Text} from "@mantine/core";
import {NavLink} from "react-router-dom";

import {ProviderMapping} from "../types.ts";
import {moduleConfig} from "../config";
import {formatTimestamp} from "../../../utils/TableTimestamps.tsx";
import {SyncStatusBadge} from "../profile/SyncStatusBadge.tsx";
import {EntityTypeBadge} from "../profile/EntityTypeBadge.tsx";

// Every column is sortable (§3a). The `accessor` is what sorts: dotted
// 'billingProvider.name' resolves through the shared comparator, timestamps sort as
// ISO-8601, and an empty providerEntityId (a Pending mapping) sorts last either way.
//
// The provider entity id is the row's link to its detail page (§3): it is what
// identifies the mapping to an operator reading a provider dashboard.
export const useProviderMappingsTableColumns = () => {

    const columns: DataTableColumn<ProviderMapping>[] = [
        {
            accessor: 'providerEntityId',
            title: I18n.get('Provider Entity ID'),
            sortable: true,
            render: (record: ProviderMapping) => (
                <NavLink to={`${moduleConfig.basePath}/${record.id}`}>
                    <Text ff='monospace' size='sm' span>
                        {record.providerEntityId || I18n.get('Not synced yet')}
                    </Text>
                </NavLink>
            ),
        },
        {
            accessor: 'entityType',
            title: I18n.get('Entity Type'),
            sortable: true,
            render: (record: ProviderMapping) => <EntityTypeBadge entityType={record.entityType}/>,
        },
        {
            accessor: 'billingProvider.name',
            title: I18n.get('Billing Provider'),
            sortable: true,
            render: (record: ProviderMapping) => record.billingProvider?.name || record.billingProviderId,
        },
        {
            accessor: 'syncStatus',
            title: I18n.get('Sync Status'),
            sortable: true,
            render: (record: ProviderMapping) => <SyncStatusBadge status={record.syncStatus}/>,
        },
        {
            accessor: 'lastSyncAt',
            title: I18n.get('Last Sync'),
            sortable: true,
            render: (record: ProviderMapping) => formatTimestamp(record.lastSyncAt),
        },
        {
            accessor: 'created',
            title: I18n.get('Created'),
            sortable: true,
            render: (record: ProviderMapping) => formatTimestamp(record.created),
        },
    ];

    return {
        columns,
    };
};
